import React from "react";
import DocMotezimage from "../../assets/icons/docket.png";

const CircularProgress = ({ className }) => (
  <div className={`loader ${className}`}>
    <img src={DocMotezimage} alt="loader" />
  </div>
);
export default CircularProgress;
